import { Head, Link } from "@inertiajs/react"
import { ArrowLeft } from "lucide-react"

export default function Privacy() {
  return (
    <>
      <Head title="Politica de Privacidad - Catador Pro" />

      <div className="mx-auto max-w-4xl px-6 py-12">
        <Link
          href="/"
          className="text-muted-foreground hover:text-foreground mb-8 flex items-center gap-2 text-sm"
        >
          <ArrowLeft className="h-4 w-4" />
          Volver al inicio
        </Link>

        <h1 className="mb-2 text-4xl font-bold">Politica de Privacidad</h1>
        <p className="text-muted-foreground mb-8">
          Ultima actualizacion: 4 de abril de 2026
        </p>

        <div className="prose prose-neutral dark:prose-invert max-w-none space-y-8">
          <section>
            <h2 className="text-2xl font-semibold">1. Introduccion</h2>
            <p>
              Catador Pro (&quot;nosotros&quot;, &quot;nuestro&quot; o &quot;la
              Plataforma&quot;) opera la plataforma web catador.pro. Esta
              Politica de Privacidad describe como recopilamos, usamos,
              almacenamos y protegemos tu informacion personal cuando utilizas
              nuestros servicios de evaluacion y catacion de cafe.
            </p>
            <p>
              Al utilizar Catador Pro, aceptas las practicas descritas en esta
              politica. Si no estas de acuerdo, por favor no utilices la
              plataforma.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold">
              2. Informacion que recopilamos
            </h2>
            <h3 className="text-lg font-medium">
              2.1 Informacion proporcionada por el usuario
            </h3>
            <ul className="list-disc space-y-1 pl-6">
              <li>
                Nombre, direccion de correo electronico y contrasena al crear tu
                cuenta
              </li>
              <li>Nombre de organizacion y datos del perfil profesional</li>
              <li>
                Datos de catacion: puntuaciones, notas sensoriales,
                descriptores, evaluaciones afectivas, descriptivas y extrinsecas
              </li>
              <li>
                Informacion de muestras de cafe: origen, productor, variedad,
                proceso
              </li>
              <li>Preferencias de idioma y configuracion de la cuenta</li>
            </ul>

            <h3 className="mt-4 text-lg font-medium">
              2.2 Informacion recopilada automaticamente
            </h3>
            <ul className="list-disc space-y-1 pl-6">
              <li>Direccion IP, tipo de navegador y sistema operativo</li>
              <li>
                Datos de uso: paginas visitadas, funcionalidades utilizadas,
                frecuencia de uso
              </li>
              <li>
                Cookies y tecnologias similares para mantener tu sesion y
                preferencias
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold">3. Uso de la informacion</h2>
            <p>Utilizamos tu informacion para:</p>
            <ul className="list-disc space-y-1 pl-6">
              <li>Proporcionar y mejorar los servicios de la plataforma</li>
              <li>Gestionar tu cuenta, organizacion y sesiones de catacion</li>
              <li>
                Generar reportes de catacion, metricas y analisis sensoriales
              </li>
              <li>
                Procesar datos con inteligencia artificial para sugerencias y
                analisis (cuando el usuario lo solicite)
              </li>
              <li>Comunicarnos contigo sobre actualizaciones del servicio</li>
              <li>
                Cumplir con obligaciones legales y proteger la seguridad de la
                plataforma
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold">4. Comparticion de datos</h2>
            <p>
              <strong>No vendemos tu informacion personal.</strong> Podemos
              compartir datos en los siguientes casos:
            </p>
            <ul className="list-disc space-y-1 pl-6">
              <li>
                <strong>Dentro de tu organizacion:</strong> los miembros de tu
                organizacion pueden ver datos de catacion compartidos segun los
                permisos configurados
              </li>
              <li>
                <strong>Reportes publicos:</strong> solo cuando tu
                explicitamente generas un enlace publico para compartir un
                reporte de catacion
              </li>
              <li>
                <strong>Proveedores de servicio:</strong> utilizamos servicios
                de terceros para hosting, analisis y procesamiento de IA (por
                ejemplo, Anthropic para funcionalidades de asistente). Estos
                proveedores estan obligados contractualmente a proteger tus
                datos
              </li>
              <li>
                <strong>Obligaciones legales:</strong> cuando sea requerido por
                ley o proceso legal
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold">
              5. Cookies y tecnologias similares
            </h2>
            <p>Utilizamos cookies para:</p>
            <ul className="list-disc space-y-1 pl-6">
              <li>
                <strong>Cookies esenciales:</strong> necesarias para el
                funcionamiento de la plataforma (autenticacion, sesion)
              </li>
              <li>
                <strong>Cookies de preferencias:</strong> recordar tu idioma y
                configuracion de apariencia
              </li>
            </ul>
            <p>
              No utilizamos cookies de publicidad ni de rastreo de terceros.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold">
              6. Seguridad de los datos
            </h2>
            <p>
              Implementamos medidas de seguridad tecnicas y organizativas para
              proteger tu informacion, incluyendo cifrado de contrasenas,
              transmision segura (HTTPS) y control de acceso basado en roles.
              Sin embargo, ninguna transmision por Internet es 100% segura y no
              podemos garantizar la seguridad absoluta.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold">7. Retencion de datos</h2>
            <p>
              Conservamos tu informacion mientras mantengas una cuenta activa en
              la plataforma. Si eliminas tu cuenta, eliminaremos tu informacion
              personal en un plazo razonable, excepto cuando debamos conservarla
              por obligaciones legales.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold">8. Tus derechos</h2>
            <p>Tienes derecho a:</p>
            <ul className="list-disc space-y-1 pl-6">
              <li>Acceder a tu informacion personal</li>
              <li>Corregir datos inexactos</li>
              <li>Solicitar la eliminacion de tu cuenta y datos</li>
              <li>Exportar tus datos de catacion</li>
              <li>Retirar tu consentimiento en cualquier momento</li>
            </ul>
            <p>
              Para ejercer estos derechos, contactanos a{" "}
              <a
                href="mailto:privacy@catador.pro"
                className="text-primary hover:underline"
              >
                privacy@catador.pro
              </a>
              .
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold">9. Privacidad de menores</h2>
            <p>
              Catador Pro no esta dirigido a menores de 16 anos. No recopilamos
              intencionalmente informacion de menores. Si descubrimos que hemos
              recopilado datos de un menor, los eliminaremos de inmediato.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold">
              10. Cambios a esta politica
            </h2>
            <p>
              Podemos actualizar esta politica periodicamente. Te notificaremos
              de cambios significativos por correo electronico o mediante un
              aviso en la plataforma. El uso continuado de Catador Pro despues
              de los cambios constituye tu aceptacion de la politica
              actualizada.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold">11. Contacto</h2>
            <p>
              Si tienes preguntas sobre esta Politica de Privacidad, contactanos
              en:
            </p>
            <p>
              <strong>Catador Pro</strong>
              <br />
              Email:{" "}
              <a
                href="mailto:privacy@catador.pro"
                className="text-primary hover:underline"
              >
                privacy@catador.pro
              </a>
              <br />
              Sitio web: catador.pro
            </p>
          </section>
        </div>

        <div className="mt-12 border-t pt-6">
          <Link href="/terms" className="text-primary text-sm hover:underline">
            Terminos y Condiciones
          </Link>
        </div>
      </div>
    </>
  )
}
